import React, { lazy, Suspense } from 'react';

import type { CitationProps } from './index.lazy';

const Citation: React.FC<CitationProps> = lazy(
  () => import('./index.lazy'),
);

const CitationSuspense: React.FC<CitationProps> = (props) => (
  <Suspense fallback={<span className="ORCIDPublicationCard__citation" />}>
    <Citation {...props} />
  </Suspense>
);

export default CitationSuspense;
